import { z } from 'zod';
import { REEL_TYPES } from '../kinds.js';
import { ENGINE_REFUSAL_CODES } from './contract.js';

/*
 * API → worker: "does this audio say this text?" (stage 4's Aligner seam). The
 * API has no engine; the worker runs it in its container (spec 5.2, 14).
 */

export const ALIGN_PATH = '/internal/engine/align';

/** An own take of 150 s at 48 kHz is ≈ 14.4 MB of WAV, ≈ 19.2 MB in base64. */
export const MAX_ALIGN_BODY_BYTES = 32 * 1024 * 1024;

export const alignRequestSchema = z.object({
  language: z.string().min(2).max(8),
  /** The draft's type: its reel limits and a theme of it; absent = scenes. */
  type: z.enum(REEL_TYPES).optional(),
  blocks: z
    .array(
      z.object({
        id: z.string().regex(/^[A-Za-z0-9_-]{1,32}$/),
        text: z.string().min(1),
        spoken: z.string().min(1).optional(),
      }),
    )
    .min(1)
    .max(40),
  /** The WAV, base64. */
  wav: z.string().min(1),
});
export type AlignRequest = z.infer<typeof alignRequestSchema>;

export const alignAnswerSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('ok'),
    verdict: z.enum(['ok', 'mismatch']),
    durationMs: z.number().int().min(0),
    costUsd: z.number().min(0),
    blocks: z.array(
      z.object({
        id: z.string(),
        matched: z.number().min(0).max(1),
        issues: z.array(
          z.object({
            type: z.enum(['missing', 'extra', 'substituted']),
            expected: z.string().optional(),
            heard: z.string().optional(),
            atMs: z.number().int().optional(),
          }),
        ),
      }),
    ),
  }),
  z.object({ kind: z.literal('refused'), code: z.enum(ENGINE_REFUSAL_CODES), message: z.string() }),
  z.object({ kind: z.literal('failed'), failure: z.string(), detail: z.string() }),
]);
export type AlignAnswer = z.infer<typeof alignAnswerSchema>;
